import _ from 'lodash';
import useAPI from '../core/hooks/useApi';

// NOTE - We don't handle errors here because they do not matter for usability
export const useGetDeployment = () => _.get(useAPI('/api/deployment'), 'data', {});
